export default __webpack_public_path__ + "static/media/bgMobile_375x3201.0d322e4e.jpg";